import React, { useMemo } from 'react';
import styles from './ProductBanner.module.scss';
import Button from '../Button/Button';
import { CloseOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { connect } from 'react-redux';
import { Typography } from 'antd';

// products: {name:string;denomination:string;price:string}[]
const ProductBanner = ({ open, products }) => {
  const dispatch = useDispatch();
  
  const onClose = () => {
    dispatch({type: 'App/BANNER_CLOSE'});
  }

  const onCartClick = () => {
    dispatch({type: 'App/SET_CART_OPEN', payload: true});
    onClose();
  }

  if (!open) return null;

  return (
    <div className={styles.container}>
      <div className={styles.closeIcon} onClick={onClose}>
        <CloseOutlined style={{ fontSize: 20 }} />
      </div>
      <div className={styles.products}>
        {products.map((product) => (
          <div key={product} className={styles.products__item}>
            <Typography style={{ fontWeight: 700}}>{product.name}</Typography>
            <Typography>{`${product.denomination} ${product.price} EUR`}</Typography>
          </div>
        ))}
      </div>
      <Button mode='contained' wide onClick={onCartClick}>
        Check cart
      </Button>
    </div>
  );
};

const mapStateToProps = (state) => ({
  products: state.app.banner.products,
  banners: state.app.banners,
  open: state.app.banner.instance !== null,
});

export default connect(mapStateToProps)(ProductBanner);
